import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";
import { OFFERINGS } from "@/data/services";

export const Offerings = () => (
  <section id="offerings" data-testid="offerings-section" className="relative py-24 bg-ark-900/50 border-y border-white/5">
    <div className="max-w-7xl mx-auto px-6">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.8 }}
        className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6"
      >
        <div>
          <p className="font-mono text-xs tracking-[0.3em] text-cyan-400 uppercase font-semibold">
            03 // Beyond the Catalog
          </p>
          <h2 className="mt-4 font-display font-bold tracking-tight text-2xl sm:text-3xl lg:text-4xl text-slate-100">
            Also <span className="metallic-text">On Offer</span>
          </h2>
        </div>
        <p className="max-w-md text-sm text-slate-400 leading-relaxed">
          Compliance audits, telecom connectivity and multi-brand products — apart from
          Microsoft, we supply and support a wide vendor ecosystem.
        </p>
      </motion.div>

      <div className="mt-12 flex flex-wrap gap-3">
        {OFFERINGS.map((o, i) => (
          <motion.span
            key={o}
            data-testid={`offering-chip-${i}`}
            initial={{ opacity: 0, scale: 0.9, y: 12 }}
            whileInView={{ opacity: 1, scale: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.45, delay: i * 0.04 }}
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-white/10 bg-ark-800/60 text-sm text-slate-300 hover:border-cyan-400/50 hover:text-white hover:shadow-[0_0_20px_rgba(56,189,248,0.15)] transition-all duration-300 cursor-default"
          >
            <Sparkles size={12} className="text-cyan-400/70" />
            {o}
          </motion.span>
        ))}
      </div>
    </div>
  </section>
);
